function updateVideoSource() {
	$("video").each(function () {
		const $video = $(this);
		const $source = $video.find("source");

		const desktopUrl = $source.data("desktop");
		const mobileUrl = $source.data("mobile");

		const newSrc = $(window).width() < 576 ? mobileUrl : desktopUrl;

		if ($source.attr("src") !== newSrc) {
			$source.attr("src", newSrc);
			$video[0].load(); // Video neu laden
		}
	});
}

// Beim Laden der Seite die richtige Quelle setzen
$(document).ready(updateVideoSource);

// Aktualisieren bei Fenstergrößenänderung
$(window).on("resize", updateVideoSource);
